<template>
  <v-container>
    <v-layout row wrap align-center class="ma-0 mt-4">
      <v-flex xs12 md12>
        <v-card flat>
          <v-card-actions>
            <v-layout row class="pa-3">
              <v-flex class="md1">
                <v-text-field v-model="filters.ano" label="Ano"></v-text-field>
              </v-flex>
              <v-flex md2 xs12 class="ml-2">
                <v-text-field
                  label="Titulo"
                  v-model="filters.search"
                ></v-text-field>
              </v-flex>
              <v-flex md2 xs12 class="ml-2">
                <v-select
                  v-model="filters.status"
                  :items="situacao"
                  label="Situação"
                  item-text="nome"
                  item-value="cod"
                ></v-select>
              </v-flex>
              <v-flex md2 xs12 class="align-items-baseline">
                <v-menu
                  v-model="show_start_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="
                        filters.inicio
                          ? moment(filters.inicio).format('DD/MM/YYYY')
                          : ''
                      "
                      label="De:"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :error-messages="
                        filters.fim && !filters.inicio
                          ? ['Informe a data de início']
                          : []
                      "
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.inicio"
                    @input="show_start_date = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md2 xs12 class="mr-2 align-items-baseline">
                <v-menu
                  v-model="show_end_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="
                        filters.fim
                          ? moment(filters.fim).format('DD/MM/YYYY')
                          : ''
                      "
                      label="Até:"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :error-messages="
                        filters.inicio && !filters.fim
                          ? ['Informe a data de fim']
                          : []
                      "
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.fim"
                    @input="show_end_date = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex class="md mt-5">
                <v-btn color="primary" x-small @click="limpar">Limpar</v-btn>
              </v-flex>
              <v-flex md2 xs12 class="mt-3" style="flex: 0 auto">
                <v-btn class="primary" append to="criar">Nova Galeria</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
        <v-progress-linear
          color="primary"
          :active="loadGaleria"
          indeterminate
          height="6"
        ></v-progress-linear>
      </v-flex>
    </v-layout>
    <v-layout class="mt-5" wrap v-if="galerias && galerias.data.length > 0">
      <v-flex md3 class="mt-3" v-for="foto in galerias.data" :key="foto.id">
        <v-card elevation="2" width="250">
          <router-link append :to="foto.id">
            <v-img
              v-if="foto.capa"
              :src="foto.capa"
              :lazy-src="require('@/assets/account-circle.png')"
              max-width="500"
              height="180"
              contain
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-img
              v-else
              :src="require('@/assets/account-circle.png')"
              :lazy-src="require('@/assets/account-circle.png')"
              max-width="500"
              height="180"
              contain
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </router-link>

          <v-card-text>
            <v-layout>
              <v-flex md10 xs10>
                <span style="padding-right: 20px; display: block">
                  {{ foto.titulo }}
                </span>
                {{ foto.data && moment(foto.data).format('DD/MM/YYYY') }}
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center v-else>
      <v-flex md12 lg12 xs12>
        <v-card class="mt-3">
          <v-card-text>
            <span class="text-center d-block">Nenhuma galeria encontrada.</span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <confirm ref="deteleFile" :confirm-fn="excluirFoto"
      >Deseja excluir este arquivo?</confirm
    >
  </v-container>
</template>

<script>
import Confirm from '../../components/Confirm'
import { Galeria } from '../../service'
export default {
  components: { Confirm },
  data() {
    return {
      filters: {
        search: null,
        status: null,
        inicio: null,
        fim: null,
        ano: new Date().getFullYear()
      },
      galerias: null,
      loadGaleria: false,
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      delay: 500,
      situacao: [
        { cod: 'P', nome: 'Pendente' },
        { cod: 'A', nome: 'Agendado' },
        { cod: 'E', nome: 'Publicado' },
        { cod: 'C', nome: 'Cadastrado' },
        { cod: 'D', nome: 'Desativado' },
        { cod: 'R', nome: 'Reprovado' }
      ],
      show_start_date: false,
      start_date: null,
      show_end_date: false,
      end_date: null,
      capas: []
    }
  },
  async created() {
    await this.load()
    //await this.carregarCapas()
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        clearTimeout(this.delay)
        this.delay = setTimeout(() => this.load(), 750)
      }
    }
  },

  methods: {
    async excluirFoto(id) {
      await Galeria.delete(id, { escola: this.escola })
      this.load()
    },
    async load() {
      this.loadGaleria = true
      this.galerias = await Galeria.filter({
        escola: this.escola,
        ...this.filters
      })
      this.loadGaleria = false
      //console.log(this.galerias)
    },
    limpar() {
      this.filters = {}
    }
    // async carregarCapas(){
    //   this.galerias.data.map( async t => {
    //     this.capas.push(await Galeria.getCapa(t.id, {escola: this.escola}))
    //   })
    // }
  }
}
</script>

<style>
a {
  text-decoration: none !important;
}
</style>
